import React from 'react';

import { Loadable } from '../../../components/navigation/Loadable';
import { allowedUserType, USER_TYPES } from '../../../utils/constants';
import { withPrivateRoute } from '../withPrivateRoute';

const { NURSE, DOCTOR, SUPPORT } = USER_TYPES;

/**
 * @satisfies {ExtendedRouteObject}
 */
export const assignedPatientsRoutes = {
  name: 'Assigned Patients',
  path: 'assigned-patients',
  type: 'item',
  ...withPrivateRoute(
    Loadable(
      React.lazy(() => import('../../../components/patient-management/assigned-patients/assigned-patients-container')),
    ),
    {
      userCanAccess: ({ userType }) => allowedUserType([NURSE, DOCTOR, SUPPORT], userType),
    },
  ),
};
